module.exports = __webpack_public_path__ + "static/media/about.35a5f4d7.svg";